type TitledEntry = {
  title?: string | null;
};

type TitleSelection = 'all' | Set<string>;

const getUniqueTitles = (entries: TitledEntry[]): string[] => {
  const titles = new Set<string>();
  for (const entry of entries) {
    const title = entry.title?.trim();
    if (title) {
      titles.add(title);
    }
  }
  return [...titles].sort((a, b) => a.localeCompare(b));
};

const reconcileTitleSelection = (
  selection: TitleSelection,
  uniqueTitles: string[],
): TitleSelection => {
  if (selection === 'all') {
    return 'all';
  }

  if (selection.size === 0) {
    return selection;
  }

  const next = new Set(uniqueTitles.filter((title) => selection.has(title)));
  if (next.size === 0) {
    return 'all';
  }

  return next;
};

const filterEntriesByTitle = <T extends TitledEntry>(
  entries: T[],
  selection: TitleSelection,
): T[] => {
  if (selection === 'all') {
    return entries;
  }

  if (selection.size === 0) {
    return [];
  }

  return entries.filter(
    (entry) => Boolean(entry.title) && selection.has(entry.title as string),
  );
};

const titleSelectionFromCheckedIds = (
  checkedIds: string[],
  uniqueTitles: string[],
): TitleSelection => {
  if (checkedIds.length === 0) {
    return new Set();
  }

  if (checkedIds.length === uniqueTitles.length) {
    return 'all';
  }

  return new Set(checkedIds);
};

export type { TitleSelection, TitledEntry };
export {
  filterEntriesByTitle,
  getUniqueTitles,
  reconcileTitleSelection,
  titleSelectionFromCheckedIds,
};
